import { UserRole } from '../types/user';

/**
 * Robustly determine whether a role value represents an interviewer.
 *
 * The API serializes the role enum as a STRING ("Interviewer" / "Interviewee",
 * because JsonStringEnumConverter is enabled on the backend), while the local
 * UserRole enum also carries NUMERIC members (Interviewer = 2). A direct
 * `role === UserRole.Interviewer` comparison therefore fails for the API value
 * (`"Interviewer" === 2` is always false). This helper normalizes both forms.
 */
export function isInterviewerRole(
  role: UserRole | string | number | null | undefined,
): boolean {
  if (role === null || role === undefined) return false;
  if (typeof role === 'number') return role === UserRole.Interviewer; // 2
  return String(role).toLowerCase() === 'interviewer'; // "Interviewer" | "interviewer"
}
